module.exports = __webpack_public_path__ + "static/rewiring_book-9e13a7ab1c3c43c54196d57995f627be.jpg";